'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var cx = require('classnames');
var reactRouterDom = require('react-router-dom');
var reactSpring = require('react-spring');
var FocusLock = require('react-focus-lock');
var bodyScrollLock = require('body-scroll-lock');
var ARRIVE_LOGO = require('@arrive/ui-icons/svg/arriveNOW_logo_short.svg');
var DOWN_ARROW = require('@arrive/ui-icons/svg/ic_dropdown.svg');
var MENU = require('@arrive/ui-icons/svg/ic_menu.svg');
var CLEAR = require('@arrive/ui-icons/svg/ic_close.svg');
var LOGOUT = require('material-design-icons/action/svg/production/ic_input_24px.svg');
var Avatar = require('@arrive/avatar');
var SVGIcon = require('@arrive/svg-icon');
var Popover = require('@arrive/popover');
var listPopover = require('@arrive/list-popover');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var FocusLock__default = /*#__PURE__*/_interopDefaultLegacy(FocusLock);
var ARRIVE_LOGO__default = /*#__PURE__*/_interopDefaultLegacy(ARRIVE_LOGO);
var DOWN_ARROW__default = /*#__PURE__*/_interopDefaultLegacy(DOWN_ARROW);
var MENU__default = /*#__PURE__*/_interopDefaultLegacy(MENU);
var CLEAR__default = /*#__PURE__*/_interopDefaultLegacy(CLEAR);
var LOGOUT__default = /*#__PURE__*/_interopDefaultLegacy(LOGOUT);
var Avatar__default = /*#__PURE__*/_interopDefaultLegacy(Avatar);
var SVGIcon__default = /*#__PURE__*/_interopDefaultLegacy(SVGIcon);
var Popover__default = /*#__PURE__*/_interopDefaultLegacy(Popover);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var styles = {"ethanol":"#fff","tandem":"#f4f5f5","chrome":"#d4d6d9","LFGray":"#9ea2a9","smokey":"#60646c","burnout":"#46494f","roadhog":"#303236","axle":"#1d1e20","grease":"#0a0a0b","bandit":"#e0f3fb","bigSky":"#b1e1f5","arrive":"#2aaae2","blueBayou":"#039ddd","nightTime":"#007dbc","blueridge":"#0062c0","gasoline":"#feefcb","diesel":"#f1ae11","mileMarker":"#e8f5e9","gatorguts":"#4caf50","frogger":"#2b731a","whoaNelly":"#ffedf1","jackknife":"#cb2024","dark":"arrive_NavBar__dark","darkLogo":"arrive_NavBar__darkLogo","darkLinkItem":"arrive_NavBar__darkLinkItem","darkHelloUser":"arrive_NavBar__darkHelloUser","darkCaret":"arrive_NavBar__darkCaret","navBar":"arrive_NavBar__navBar","navItemsContainer":"arrive_NavBar__navItemsContainer","userAccountItem":"arrive_NavBar__userAccountItem","navLink":"arrive_NavBar__navLink","mainNavItem":"arrive_NavBar__mainNavItem","selected":"arrive_NavBar__selected","skateboard":"arrive_NavBar__skateboard","sideNavigation":"arrive_NavBar__sideNavigation","logoSection":"arrive_NavBar__logoSection","sideNavigationRoadhog":"arrive_NavBar__sideNavigationRoadhog","navButton":"arrive_NavBar__navButton","navItemsList":"arrive_NavBar__navItemsList","sideNavigationOpen":"arrive_NavBar__sideNavigationOpen","logo":"arrive_NavBar__logo","navItemIcon":"arrive_NavBar__navItemIcon","avatar":"arrive_NavBar__avatar","otherChildren":"arrive_NavBar__otherChildren","childContent":"arrive_NavBar__childContent","helloUser":"arrive_NavBar__helloUser","helloUserContainer":"arrive_NavBar__helloUserContainer","initialsAvatar":"arrive_NavBar__initialsAvatar","initialsAvatarMd":"arrive_NavBar__initialsAvatarMd","profileCaret":"arrive_NavBar__profileCaret","overlay":"arrive_NavBar__overlay","popoverItem":"arrive_NavBar__popoverItem","darkItem":"arrive_NavBar__darkItem","userPopoverParent":"arrive_NavBar__userPopoverParent","userPopoverContainer":"arrive_NavBar__userPopoverContainer","userDropdownTop":"arrive_NavBar__userDropdownTop","userDropdownName":"arrive_NavBar__userDropdownName","userDropdownEmail":"arrive_NavBar__userDropdownEmail","userDropdownDark":"arrive_NavBar__userDropdownDark"};

var getTestIdFromTitle = function getTestIdFromTitle(title) {
  var lcTitle = title ? title.toLowerCase() : '';

  if (lcTitle) {
    return "nav-".concat(lcTitle.replace(/ /g, '-'));
  }

  return lcTitle;
};

var NavigationLinkItem = function NavigationLinkItem(_ref) {
  var to = _ref.to,
      children = _ref.children,
      isNavItem = _ref.isNavItem,
      className = _ref.className,
      externalURL = _ref.externalURL,
      isSelected = _ref.isSelected,
      onClick = _ref.onClick,
      _ref$openExternalInNe = _ref.openExternalInNewTab,
      openExternalInNewTab = _ref$openExternalInNe === void 0 ? true : _ref$openExternalInNe,
      title = _ref.title;
  return /*#__PURE__*/React__default["default"].createElement("li", {
    className: cx__default["default"](styles.navLink, className, _defineProperty({}, styles.selected, isSelected))
  }, externalURL ? /*#__PURE__*/React__default["default"].createElement("a", {
    "data-testid": getTestIdFromTitle(title),
    onClick: onClick,
    href: to,
    target: openExternalInNewTab && "_blank",
    rel: "noopener noreferrer"
  }, children) : /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Link, {
    "data-testid": getTestIdFromTitle(title),
    to: to,
    onClick: onClick
  }, " ", children), isNavItem && /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.skateboard
  }));
};

NavigationLinkItem.displayName = 'NavigationLinkItem';
NavigationLinkItem.propTypes = {
  to: PropTypes__default["default"].string.isRequired,
  children: PropTypes__default["default"].node.isRequired,
  isNavItem: PropTypes__default["default"].bool,
  className: PropTypes__default["default"].string,
  externalURL: PropTypes__default["default"].bool,
  title: PropTypes__default["default"].string
};

function SideNavigationBar(_ref2) {
  var _cx2;

  var closeSideNavOnExternalClick = _ref2.closeSideNavOnExternalClick,
      currentUser = _ref2.currentUser,
      userLinkToItems = _ref2.userLinkToItems,
      mainLinkToItems = _ref2.mainLinkToItems,
      homeLinkTo = _ref2.homeLinkTo,
      homeLinkExternalURL = _ref2.homeLinkExternalURL,
      className = _ref2.className,
      theme = _ref2.theme,
      onLogout = _ref2.onLogout,
      logo = _ref2.logo,
      logoClassName = _ref2.logoClassName;
  var currentRoute = reactRouterDom.useLocation();

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      openSideNavigation = _useState2[1];

  var navlistRef = React.useRef();
  React.useEffect(function () {
    // give it a sec to allow animations to occur
    setTimeout(function () {
      return openSideNavigation(false);
    }, 200);
  }, [currentRoute]);
  React.useEffect(function () {
    var closeOnEscape = function closeOnEscape(evt) {
      if (evt.keyCode === 27) {
        openSideNavigation(false);
      }
    };

    if (isOpen && navlistRef.current) {
      document.addEventListener("keydown", closeOnEscape);
      bodyScrollLock.disableBodyScroll(navlistRef.current);
    } else if (navlistRef.current) {
      bodyScrollLock.enableBodyScroll(navlistRef.current);
    }

    return function () {
      bodyScrollLock.clearAllBodyScrollLocks();
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [isOpen]);
  var transition = reactSpring.useTransition(isOpen, null, {
    config: {
      mass: 1,
      tension: 180,
      friction: 26
    },
    from: {
      transform: "translateX(-100%)"
    },
    enter: {
      transform: "translateX(0)"
    },
    leave: {
      transform: "translateY(-100%)"
    }
  });

  var externalClickHandler = function externalClickHandler() {
    if (closeSideNavOnExternalClick) {
      openSideNavigation(false);
    }
  };

  return /*#__PURE__*/React__default["default"].createElement("nav", {
    className: cx__default["default"](styles.navBar, className, styles.sideNavigation, (_cx2 = {}, _defineProperty(_cx2, styles.sideNavigationOpen, isOpen), _defineProperty(_cx2, styles.sideNavigationRoadhog, theme === 'roadhog'), _cx2))
  }, /*#__PURE__*/React__default["default"].createElement(FocusLock__default["default"], {
    disabled: !isOpen,
    shards: [navlistRef]
  }, /*#__PURE__*/React__default["default"].createElement("ul", {
    className: styles.navItemsList
  }, /*#__PURE__*/React__default["default"].createElement(Popover__default["default"], {
    showPopover: isOpen,
    setShowPopover: openSideNavigation,
    placement: "bottom-start",
    popperContent: transition.map(function (_ref3) {
      var item = _ref3.item,
          key = _ref3.key,
          props = _ref3.props;
      return item ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, {
        key: "side-nav-drawer"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: styles.overlay,
        key: "side-nav-overlay",
        onClick: externalClickHandler
      }), /*#__PURE__*/React__default["default"].createElement(reactSpring.animated.ul, {
        ref: navlistRef,
        "data-testid": "side-nav-drawer",
        key: key,
        style: props,
        className: styles.navItemsContainer
      }, mainLinkToItems.map(function (mainItem) {
        return /*#__PURE__*/React__default["default"].createElement(NavigationLinkItem, _extends({
          key: mainItem.to,
          className: styles.mainNavItem
        }, mainItem, {
          isNavItem: true
        }), mainItem.title);
      }), currentUser && userLinkToItems.map(function (userListItem, idx) {
        return /*#__PURE__*/React__default["default"].createElement(NavigationLinkItem, _extends({
          key: userListItem.to
        }, userListItem, {
          className: cx__default["default"](_defineProperty({}, styles.userAccountItem, idx === 0))
        }), !!userListItem.svg && /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
          svgRef: userListItem.svg,
          className: styles.navItemIcon
        }), userListItem.title);
      }), currentUser && /*#__PURE__*/React__default["default"].createElement(NavigationLinkItem, {
        to: currentUser.LogoutURL,
        onClick: onLogout,
        title: "logout",
        externalURL: true
      }, /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
        svgRef: LOGOUT__default["default"],
        className: styles.navItemIcon
      }), "Logout"))) : null;
    })
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.logoSection
  }, /*#__PURE__*/React__default["default"].createElement("li", null, /*#__PURE__*/React__default["default"].createElement("button", {
    onClick: function onClick() {
      return openSideNavigation(!isOpen);
    },
    className: styles.navButton
  }, /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
    svgRef: isOpen ? CLEAR__default["default"] : MENU__default["default"]
  }))), /*#__PURE__*/React__default["default"].createElement(NavigationLinkItem, {
    title: "default home logo",
    to: homeLinkTo,
    externalURL: homeLinkExternalURL
  }, /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
    className: cx__default["default"](styles.logo, logoClassName, _defineProperty({}, styles.darkLogo, theme === 'roadhog')),
    svgRef: logo ? logo : ARRIVE_LOGO__default["default"]
  })))))));
}

var NavBar = /*#__PURE__*/React__default["default"].forwardRef(function (_ref4, ref) {
  var currentUser = _ref4.currentUser,
      currentMediaTypes = _ref4.currentMediaTypes,
      homeLinkExternalURL = _ref4.homeLinkExternalURL,
      _ref4$homeLinkTo = _ref4.homeLinkTo,
      homeLinkTo = _ref4$homeLinkTo === void 0 ? "/" : _ref4$homeLinkTo,
      userLinkToItems = _ref4.userLinkToItems,
      mainLinkToItems = _ref4.mainLinkToItems,
      className = _ref4.className,
      otherChildren = _ref4.otherChildren,
      _ref4$theme = _ref4.theme,
      theme = _ref4$theme === void 0 ? "ethanol" : _ref4$theme,
      onLogout = _ref4.onLogout,
      _ref4$closeSideNavOnE = _ref4.closeSideNavOnExternalClick,
      closeSideNavOnExternalClick = _ref4$closeSideNavOnE === void 0 ? true : _ref4$closeSideNavOnE,
      logo = _ref4.logo,
      logoClassName = _ref4.logoClassName;

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showPopover = _useState4[0],
      setShowPopover = _useState4[1];

  var userDropdownButton = React.useRef();

  var closeCallback = function closeCallback() {
    return setShowPopover(false);
  };

  if (currentMediaTypes.xs || currentMediaTypes.sm) {
    return /*#__PURE__*/React__default["default"].createElement(SideNavigationBar, {
      closeSideNavOnExternalClick: closeSideNavOnExternalClick,
      theme: theme,
      currentUser: currentUser,
      homeLinkTo: homeLinkTo,
      homeLinkExternalURL: homeLinkExternalURL,
      userLinkToItems: userLinkToItems,
      mainLinkToItems: mainLinkToItems,
      className: className,
      onLogout: onLogout,
      logo: logo,
      logoClassName: logoClassName
    });
  }

  function createUserItems() {
    var items = [/*#__PURE__*/React__default["default"].createElement("div", {
      key: "user-info-section",
      className: styles.userDropdownTop
    }, /*#__PURE__*/React__default["default"].createElement(Avatar__default["default"], {
      size: "md",
      firstName: currentUser.FirstName,
      lastName: currentUser.LastName,
      pictureUrl: currentUser.PictureUrl
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: cx__default["default"](styles.userDropdownName, _defineProperty({}, styles.userDropdownDark, theme === 'roadhog'))
    }, currentUser.FullName), /*#__PURE__*/React__default["default"].createElement("div", {
      className: cx__default["default"](styles.userDropdownEmail, _defineProperty({}, styles.userDropdownDark, theme === 'roadhog'))
    }, currentUser.EmailAddress))];
    var logoutItem = [/*#__PURE__*/React__default["default"].createElement(listPopover.PopoverListItem, {
      key: "logout-link",
      onClick: closeCallback,
      className: cx__default["default"](styles.popoverItem, _defineProperty({}, styles.darkItem, theme === 'roadhog'))
    }, /*#__PURE__*/React__default["default"].createElement("a", {
      "data-testid": "nav-logout",
      href: currentUser.LogoutURL,
      onClick: onLogout
    }, /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
      svgRef: LOGOUT__default["default"],
      className: styles.navItemIcon
    }), "Logout"))];
    var restItems = userLinkToItems.map(function (userLink) {
      return /*#__PURE__*/React__default["default"].createElement(listPopover.PopoverListItem, {
        key: userLink.to,
        onClick: closeCallback,
        className: cx__default["default"](styles.popoverItem, _defineProperty({}, styles.darkItem, theme === 'roadhog'))
      }, userLink.externalURL ? /*#__PURE__*/React__default["default"].createElement("a", {
        "data-testid": getTestIdFromTitle(userLink.title),
        href: userLink.to,
        target: userLink.openExternalInNewTab && "_blank",
        rel: "noopener noreferrer"
      }, !!userLink.svg && /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
        svgRef: userLink.svg,
        className: styles.navItemIcon
      }), userLink.title) : /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Link, {
        "data-testid": getTestIdFromTitle(userLink.title),
        to: userLink.to,
        target: userLink.openExternalInNewTab && "_blank"
      }, !!userLink.svg && /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
        svgRef: userLink.svg,
        className: styles.navItemIcon
      }), userLink.title));
    });
    return items.concat(restItems).concat(logoutItem);
  }

  return /*#__PURE__*/React__default["default"].createElement("nav", {
    className: cx__default["default"](styles.navBar, _defineProperty({}, styles.dark, theme === "roadhog"), className),
    ref: ref
  }, /*#__PURE__*/React__default["default"].createElement("ul", null, /*#__PURE__*/React__default["default"].createElement(NavigationLinkItem, {
    title: "default home logo",
    to: homeLinkTo,
    externalURL: homeLinkExternalURL
  }, /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
    className: cx__default["default"](styles.logo, logoClassName, _defineProperty({}, styles.darkLogo, theme === 'roadhog')),
    svgRef: logo ? logo : ARRIVE_LOGO__default["default"]
  })), mainLinkToItems.map(function (mainItem) {
    return /*#__PURE__*/React__default["default"].createElement(NavigationLinkItem, _extends({
      key: mainItem.to,
      className: cx__default["default"](_defineProperty({}, styles.darkLinkItem, theme === 'roadhog'))
    }, mainItem, {
      isNavItem: true
    }), mainItem.title);
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.otherChildren
  }, otherChildren && /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.childContent
  }, otherChildren), currentUser && /*#__PURE__*/React__default["default"].createElement(listPopover.ListPopover, {
    classes: {
      anchorClass: styles.helloUserContainer,
      contentContainerClass: styles.userPopoverParent,
      listContainerClass: styles.userPopoverContainer
    },
    listItems: createUserItems(),
    placement: "bottom-end",
    showPopover: showPopover,
    setShowPopover: setShowPopover,
    focusLockProps: {
      shards: [userDropdownButton]
    },
    theme: theme
  }, /*#__PURE__*/React__default["default"].createElement("button", {
    onClick: function onClick() {
      return setShowPopover(!showPopover);
    },
    className: cx__default["default"](styles.helloUser, _defineProperty({}, styles.darkHelloUser, theme === 'roadhog')),
    "aria-expanded": showPopover,
    ref: userDropdownButton
  }, "Hello, ", currentUser.FirstName, /*#__PURE__*/React__default["default"].createElement(Avatar__default["default"], {
    firstName: currentUser.FirstName,
    lastName: currentUser.LastName,
    pictureUrl: currentUser.PictureUrl
  }), /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
    svgRef: DOWN_ARROW__default["default"],
    className: cx__default["default"](styles.profileCaret, _defineProperty({}, styles.darkCaret, theme === 'roadhog'))
  }))))));
});
NavBar.displayName = 'NavBar';
NavBar.propTypes = {
  currentUser: PropTypes__default["default"].shape({
    LogoutURL: PropTypes__default["default"].string.isRequired,
    FirstName: PropTypes__default["default"].string.isRequired,
    FullName: PropTypes__default["default"].string.isRequired,
    EmailAddress: PropTypes__default["default"].string.isRequired
  }),
  currentMediaTypes: PropTypes__default["default"].shape({
    xs: PropTypes__default["default"].bool,
    sm: PropTypes__default["default"].bool,
    md: PropTypes__default["default"].bool,
    lg: PropTypes__default["default"].bool,
    xl: PropTypes__default["default"].bool
  }).isRequired,
  homeLinkTo: PropTypes__default["default"].string,
  homeLinkExternalURL: PropTypes__default["default"].bool,
  userLinkToItems: PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape({
    to: PropTypes__default["default"].string.isRequired,
    svg: PropTypes__default["default"].object,
    title: PropTypes__default["default"].string.isRequired,
    openExternalInNewTab: PropTypes__default["default"].bool,
    externalURL: PropTypes__default["default"].bool
  })),
  mainLinkToItems: PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape({
    to: PropTypes__default["default"].string.isRequired,
    title: PropTypes__default["default"].string.isRequired,
    openExternalInNewTab: PropTypes__default["default"].bool,
    externalURL: PropTypes__default["default"].bool
  })),
  otherChildren: PropTypes__default["default"].node,
  className: PropTypes__default["default"].string,
  onLogout: PropTypes__default["default"].func,
  theme: PropTypes__default["default"].oneOf(['roadhog', 'ethanol']),

  /**
  * This prop allows for the small screen size nav bar to close on clicks outside of the side nav popover.
  */
  closeSideNavOnExternalClick: PropTypes__default["default"].bool,
  logo: PropTypes__default["default"].any
};

module.exports = NavBar;
